import MainLayout from "../../../../components/mainLayout";
import { PAGES } from "../../../../routes";
import audio from "../../../../assets/audio/16.mp3"
export default function P1() {
    return (
        <MainLayout
            title="Po spotkaniu z rzemieślnikami"
            question=""
            audio={audio}
            answers={{
                ans1: "Dalej",
            }}
            links={{
                link1: PAGES.p31,
            }}
            content={
                <div>
                    <p>
                        Drugi dzień dał ci w kość. Masz jednak zapewniony nocleg, a Emil jest serdecznym gospodarzem, więc postanawiasz, że nie poddasz się od razu i poszukasz jeszcze szczęścia w Zagórowie. A może rzeczywiście znaleźć tych gęsiarzy? Wczoraj wieczorem było widać dużo gęsi na łąkach w drodze do Tarszewa. Wyruszasz w tamtą stronę, żeby porozmawiać choćby z jednym gęsiarzem.
                    </p>
                </div>
            }
        />

    );
}